import styles from './CheckBoxIcon.module.scss';

type checkBoxTypes = {
  checked: boolean;
};

const CheckboxIcon = (props: checkBoxTypes) => {
  const { checked } = props;

  return (
    <div className={styles.checkbox}>
      {checked && (
        <svg>
          <path d='M14 21.414l-5-5.001L10.413 15 14 18.586 21.585 11 23 12.415l-9 8.999z' />
        </svg>
      )}
    </div>
  );
};

export default CheckboxIcon;
